import React, { useEffect, useState } from 'react';
import { PagingQuery } from 'tea-component';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import { MetricsTableCloums } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/MetricsTableCloums';
import { getMetricValueOfCvmGame } from '../_utils';
import { useHistory } from 'umi';
import FirstRowEdition from '@/pages/intelligence/components/TableComponents/components/FirstRowEdition';
import TopchartTable from '@/pages/intelligence/components/TableComponents/TopchartTable';
import ARightClickToJump from '@/pages/intelligence/components/ARightClickToJump';
import { getDetailGameOverviewPath } from '@/pages/intelligence/utils/topchartsUtils';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';

const TrendsCard = (props: any) => {
  const {
    tableData = [],
    pageId,
    dateType,
    tableTotal,
    columnsList,
    tableLoading,
    onTableSortChage,
    onTablePagingChange,
    segementType,
    entityType,
  } = props;

  const history = useHistory();
  const { formatMessage } = useIntlExtend();
  const [sortTableData, setSortTableData] = useState(tableData);
  const [pageSortAttr, setPageSortAttr] = useState({
    currentSortValue: 'desc',
    currentSortMetric: segementType,
    currentRatioType: 0,
  });
  const defaultPageSize = 5;
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(defaultPageSize);

  const {
    // tablePageIndex,
    // tablePageSize,
    currentSortValue,
    currentSortMetric,
    currentRatioType,
  } = pageSortAttr || {};

  useEffect(() => {
    setSortTableData(tableData);
  }, [JSON.stringify(tableData)]);

  const onSortChage = (e: SortByItemType) => {
    setPageSortAttr({
      currentSortValue: e.sortVal,
      currentSortMetric: e.sortMetric,
      currentRatioType: e?.ratioType || 0,
    });
    onTableSortChage(e);
    //将页码重置,与接口一至
    setPageIndex(1);
    setPageSize(defaultPageSize);
  };

  const getNoDropdown = (value: string, segementType: string) => {
    if (segementType === 'digitalRevenue') {
      return value === 'units';
    } else if (segementType === 'units') {
      return value === 'digitalRevenue';
    }
    return false;
  };
  const getMetricCloums = () => {
    const metricCloums: any[] = [];
    columnsList?.forEach((t: any) => {
      metricCloums.push(
        MetricsTableCloums({
          isNoDropdown: getNoDropdown(t.value, segementType),
          onlySimpleSort: false,
          renderType: t?.renderType,
          width: t?.width,
          width_cn: t?.width_cn,
          dataSource: t?.dataSource, //source === 'ogdb' ? 'databarin' : source,
          title: t?.text,
          textContent: t?.info,
          tipText: t?.iconInfo,
          key: `${t?.value}`,
          sortMetric: t?.value,
          currentSortValue: currentSortValue,
          currentSortKey: `${currentSortMetric}_${currentRatioType}`,
          onSortChage: onSortChage,
          dateType: dateType,
          pageId: pageId,
          getMetricValueOfCvm: getMetricValueOfCvmGame,
          growthValueType: 'percentValue',
          formatMessage,
          entityType
        }),
      );
    });
    return metricCloums;
  };

  const onPagingChange = (e: PagingQuery) => {
    setPageIndex(e.pageIndex || 1);
    setPageSize(e.pageSize || defaultPageSize);
    onTablePagingChange(e);
  };

  const onClickGame = (gameId: string) => {
    history.push(getDetailGameOverviewPath(gameId, entityType));
  };

  return (
    <>
      <TopchartTable
        recordKey="id"
        loading={tableLoading}
        records={sortTableData}
        tableTotal={tableTotal}
        pageIndex={pageIndex}
        pageSize={pageSize}
        onPagingChange={onPagingChange}
        pageSizeOptions={[5, 10, 15]}
        className="dbi-mobileGames-details-table"
        columns={[
          {
            key: 'id',
            header: (
              <div className="stats-table-title">
                <span className="stats-table-title-text">
                  {formatMessage({ id: 'dbi_games' })}
                </span>
                {/* <span className="stats-table-title-subtext">
                  ({tableTotal || 0})
                </span> */}
              </div>
            ),
            width: 300,
            align: 'left',
            render: (cvm: any) => {
              if (cvm?.game_name === 'Total') {
                return <>{formatMessage({ id: 'dbi_detail_table_total' })}</>;
              }
              return (
                <ARightClickToJump
                  href={getDetailGameOverviewPath(cvm?.game_id, entityType)}
                  style={{ display: 'inline' }}
                >
                  <FirstRowEdition
                    name={cvm?.game_name}
                    isUnPublished={false}
                    platform={cvm?.platform}
                    imgSrc={cvm?.cover}
                    onClick={() => {
                      onClickGame(cvm?.game_id);
                    }}
                  />
                </ARightClickToJump>
              );
            },
          },
          ...getMetricCloums(),
        ]}
      />
    </>
  );
};

export default TrendsCard;
